import React from 'react';
import { makeStyles, styled, fade } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const useStyles = makeStyles((theme) => ({
  select: {
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 8,
    fontSize: 14,
    fontWeight: 700,
    backgroundColor: '#EFF2F5',
    borderRadius: 4,
  },
  item: {
    fontSize: 'inherit',
  },
  selectStatus: {
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 8,
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 1.5,
  },
}));

const CustomSelect = styled(({ color, ...other }) => <Select {...other} />)({
  'backgroundColor': (props) =>
    props.backgroundColor || fade(props.color, 0.05),
  'color': (props) => props.color || 'inherit',
  'borderRadius': 6,
  '& .MuiSelect-icon': {
    top: 'calc(50% - 15px)',
    color: (props) => props.color,
    overflow: 'hidden',
  },
});

const Dropdown = ({
  options,
  placeholder = 'Select',
  backgroundColor,
  color = '#696D75',
  onChange,
  value,
  showValue,
  disabled,
  ...other
}) => {
  const classes = useStyles();

  return (
    <CustomSelect
      disableUnderline
      displayEmpty
      value={value || ''}
      classes={{
        select: classes.selectStatus,
      }}
      style={{ marginRight: 8 }}
      onChange={(e) => onChange(e.target.value)}
      color={color}
      backgroundColor={backgroundColor}
      renderValue={(val) => {
        if(showValue)
            return options.find((s) => s.value === val)?.value || placeholder;

        return options.find((s) => s.value === val)?.label || placeholder;
      }}
      {...other}
    >
      {options.map((i) => (
        <MenuItem
          disabled={disabled}
          classes={{ root: classes.item }}
          key={i.value}
          value={i.value}
        >
          {i.label}
        </MenuItem>
      ))}
    </CustomSelect>
  );
};

export default Dropdown;
